export default __webpack_public_path__ + "static/media/medaille-bdo-argent-realisation.0b2db642.png";